export const UploadingButton = ({htmlFor, iconClass , id , acceptInputType, getAttachement}) => {
    return (
        <div className="mr-10 avatar">
            <label htmlFor={htmlFor} role="button" className="avatar-content text-dark mb-0">
                <i className={iconClass}></i>
            </label>
            <input type="file" id={id} hidden accept={acceptInputType} onChange={(e) => getAttachement(e, id)} onClick={e => e.target.value = null}/>
        </div>
    )
}